// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"NewsletterConfirmationPopup_Wrapper__3l7Gb","Image":"NewsletterConfirmationPopup_Image__tOw0s","Content":"NewsletterConfirmationPopup_Content__2JlgP"};